import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { VisualizadorService } from 'src/app/components/shared/service/visualizador.service';

@Component({
  selector: 'app-opinion',
  templateUrl: './opinion.component.html',
  styleUrls: ['./opinion.component.css']
})
export class OpinionComponent implements OnInit{
  public isAgradecimientos: boolean = false;
  public razonOpinion: string = '';
  public correoElectronico: string = '';
  public parrafoTratamientoDatos:SafeHtml = '';
  public proteccionDatosPersonales: boolean = false;

  public errores = {
    correoObligatorio: false,
    correoinvalido: false,
    opinion: false
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<OpinionComponent>, private service: VisualizadorService, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.getParamTratamientoDatos();
  }

  closeDialog() {
    this.dialogRef.close();
  }



  public enviarOpinion() {
    const emailPattern = /^[a-zA-Z]+([.-]?[a-zA-Z0-9]+)*@([a-zA-Z]+([.-]?[a-zA-Z]))[.]{1}[a-zA-Z]{2,}$/;
    if (this.correoElectronico != '' && this.correoElectronico.includes('@')) {
      this.service.compartirOpinion(this.razonOpinion, this.correoElectronico).subscribe({
        next: (jsonWebMenu) => {
          this.isAgradecimientos = true;
        },
        error: (error) => {
          console.log("Error inesperado en getInformacionMenu", error);
        }
      });
    } else {
      this.errores.correoObligatorio = true;
    }
  }

  private getParamTratamientoDatos() {
    this.service.consultaParametro('TEXTO_TRATAMIENTO_DATOS').subscribe({
      next: (response) => {
        console.log('parrafoTratamientoDatos',response);
        this.parrafoTratamientoDatos = this.sanitizer.bypassSecurityTrustHtml(response);
      },
      error: (error) => {
        console.log("Error inesperado en getMenuXOpcion", error);
      }
    });
  }

}
